import { Outlet } from 'react-router';

import Main from '~/components/layout/Main';

function App() {
  return (
    <Main>
      <Outlet />
    </Main>
  );
}

export default App;
